import { MatrixError } from 'matrix-js-sdk/src/matrix';

const USER_NOT_FOUND_ERRCODES = new Set(['M_NOT_FOUND', 'M_INVALID_PARAM']);

export function isMatrixUserNotFoundError(error: unknown): boolean {
  if (!(error instanceof MatrixError)) return false;

  const errcode = error.errcode ?? error.data?.errcode;
  if (errcode && USER_NOT_FOUND_ERRCODES.has(errcode)) return true;
  if (error.httpStatus === 404 || error.httpStatus === 502) return true;

  return false;
}
